import Cookies from 'js-cookie'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    pixelPicListQuery: {
      pageNum: 1,
      pageSize: 10,
    }
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    // 设置页码状态
    SET_PAGE_STATE(state, listQuery) {
      state.pixelPicListQuery = listQuery;
    },
    // 清除页码状态
    CLEAR_PAGE_STATE(state) {
      state.pixelPicListQuery = {
        pageNum: 1,
        pageSize: 10,
      }
    }
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    // 更新页码状态
    updatePageState({ commit }, listQuery) {
      commit('SET_PAGE_STATE', listQuery)
    },
    // 获取页码状态
    // getPageState({ state }) {
    //   return state.listQuery || {} // 默认返回第一页
    // },
    // 清除页码状态
    clearPageState({ commit }) {
      commit('CLEAR_PAGE_STATE')
    }
  },
  getters: {
    // 获取特定页面的页码
    getPage: (state) => () => {
      return state.pixelPicListQuery;
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js